import { useMemo } from "react";

import Box from "ds/components/Box";
import { RunWorkerMetrics, RunWorkerOutcome } from "types/generated";

import { RunObservabilityFinding } from "../Findings/types";
import RunObservabilityStatTileCard from "./Tile";
import { toRunObservabilityStatTiles } from "./utils";

type RunObservabilityStatTilesProps = {
  workerMetrics: RunWorkerMetrics;
  findings: RunObservabilityFinding[];
  outcome: RunWorkerOutcome | null | undefined;
};

const RunObservabilityStatTiles = ({
  workerMetrics,
  findings,
  outcome,
}: RunObservabilityStatTilesProps) => {
  const tiles = useMemo(
    () => toRunObservabilityStatTiles(workerMetrics, findings, outcome),
    [workerMetrics, findings, outcome]
  );

  if (tiles.length === 0) {
    return null;
  }

  return (
    <Box direction="row" gap="large" wrap fullWidth>
      {tiles.map((tile) => (
        <RunObservabilityStatTileCard key={tile.id} {...tile} />
      ))}
    </Box>
  );
};

export default RunObservabilityStatTiles;
